export default {
    "主页": "Profile",
    "作品": "Works",
    "文章": "Articles",
    "看单": "Playlist",
    "喜欢": "Like",
    "简介": "Intro",
    "招聘职位": "招聘职位",
    "千万": "0M",
    "万": "0K",
    "千亿": "00B",
    "亿": "00M",
    "万亿": "T",
    "千万亿": "000T",
    "创建的看单": "My Playlists",
    "什么是看单": "What's playlist?",
    "新建看单": "Create new playlist",
    "编辑信息": "Edit",
    "删除": "Delete",
    "展开全部": "Expand All",
    "收起": "Fold",
    "收藏的看单": "Collected Playlists",
    "此看单已被设置为私密": "Private playlist",
    "此看单已被删除": "Deleted playlist ",
    "此看单不存在": "The playlist does not exist",
    "取消收藏": "Remove",
    "文章": "Articles",
    "活动": "Events",
    "当前看单审核不通过": "The playlist didn't pass the audit",
    "编辑": "Edit",
    "创建者": "Created by ",
    "个视频": " videos",
    "私密": "Private",
    "公开": "Public",
    "播放全部": "Play All",
    "该看单暂无内容": "Empty playlist",
    "暂无收藏的文章": "Empty",
    "暂无收藏的活动": "Empty",
    "编辑看单信息": "Edit playlist",
    "看单名称": "Title",
    "是否公开": "Public or private",
    "取消": "Cancel",
    "确定": "OK",
    "删除看单": "Delete",
    "是否删除该看单？": "Confirm to delete the playlist?",
    "是否取消收藏该看单？": "Confirm to save the playlist?",
    "否": "No",
    "是": "Yes",
    "名称不能为空！": "Title required",
    "请输入名称": "Please input title",
    "共": "",
    "篇文章": " articles",
    "个活动": " events",
    "是否取消收藏该视频？": "Confirm to remove the video?",
    "该看单还没有收藏视频！": "Empty playlist",
    "请至少选择一个看单！": "One or more playlist must be selected",
    "拖拽可调整排序": "Drag and drop to sort",
    "移动到": "Move to",
    "移动到看单": "Move to playlist",
    "还没有创建的看单": "You haven't created any playlist",
    "还没有收藏的看单": "You haven't collected any playlist",
    "创作者": "Artists",
    "取消收藏此看单": "Remove this playlist",
    "收藏此看单": "Collect this playlist",
    "返回首页": "Back",
    "此看单暂无内容": "Empty playlist",
    "收藏到看单": "Save to playlist",
    "取消收藏成功！": "Success!",
    "更新": "Updated at {time}",
    "看单主页": "Playlist Home",
    "已收藏": "Saved",
    "更新收藏成功！": "Update Success!",
    "推荐看单": "Recommended Playlist",
}


// WEBPACK FOOTER //
// ./src/languages/en/collect.js